import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';

// Context
import { AuthProvider } from './context/AuthContext';

// Common Components
import { ScrollToTop } from './components/common/ScrollToTop';

// Pages
import { HomePage } from './pages/HomePage';
import { DealsPage } from './pages/DealsPage';
import { DealDetailPage } from './pages/DealDetailPage';
import { PostAdPage } from './pages/PostAdPage';
import { ContactPage } from './pages/ContactPage';
import { SupportPage } from './pages/SupportPage';
import { BookmarksPage } from './pages/BookmarksPage';
import { LoginPage } from './pages/LoginPage';
import { AdminPage } from './pages/AdminPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { CityDealsPage, AreaDealsPage, CategoryDealsPage } from './pages/SEOPages';

// Smart Business QR (isolated module)
import { SmartQRLandingPage } from './pages/smartqr/SmartQRLandingPage';
import { SmartQRCreatePage } from './pages/smartqr/SmartQRCreatePage';
import { MyQRPage } from './pages/smartqr/MyQRPage';
import { PublicBusinessPage } from './pages/smartqr/PublicBusinessPage';
import { ManagePage } from './pages/smartqr/ManagePage';
import { SmartQRDirectoryPage } from './pages/smartqr/SmartQRDirectoryPage';

const App = () => (
  <HelmetProvider>
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/deals" element={<DealsPage />} />
          <Route path="/deal/:id" element={<DealDetailPage />} />
          <Route path="/post-ad" element={<PostAdPage />} />
          <Route path="/bookmarks" element={<BookmarksPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />

          {/* Smart Business QR */}
          <Route path="/smart-business-qr" element={<SmartQRLandingPage />} />
          <Route path="/smart-business-qr/create" element={<SmartQRCreatePage />} />
          <Route path="/smart-business-qr/shops" element={<SmartQRDirectoryPage />} />
          <Route path="/smart-business-qr/my/:businessId/:ownerKey" element={<MyQRPage />} />
          <Route path="/b/:slug" element={<PublicBusinessPage />} />
          <Route path="/manage/:businessId/:token" element={<ManagePage />} />
          <Route path="/admin/smart-qr/new" element={<SmartQRCreatePage adminMode />} />
          <Route path="/admin/smart-qr/:businessId" element={<ManagePage adminMode />} />
          
          {/* SEO Routes - Must be after specific routes */}
          {/* City Pages: /pune-deals, /mumbai-deals */}
          <Route path="/pune-deals" element={<CityDealsPage />} />
          <Route path="/mumbai-deals" element={<CityDealsPage />} />
          <Route path="/bangalore-deals" element={<CityDealsPage />} />
          <Route path="/delhi-deals" element={<CityDealsPage />} />
          <Route path="/hyderabad-deals" element={<CityDealsPage />} />
          
          {/* Area Pages: /pune/kharadi-deals */}
          <Route path="/pune/:areaSlug" element={<AreaDealsPage />} />
          <Route path="/mumbai/:areaSlug" element={<AreaDealsPage />} />
          <Route path="/bangalore/:areaSlug" element={<AreaDealsPage />} />
          <Route path="/delhi/:areaSlug" element={<AreaDealsPage />} />
          <Route path="/hyderabad/:areaSlug" element={<AreaDealsPage />} />
          
          {/* Category Pages: /fashion-deals-pune */}
          <Route path="/:categorySlug" element={<CategoryDealsPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  </HelmetProvider>
);

export default App;
